export default __webpack_public_path__ + "static/media/logo_GMX_.b956aa96.svg";